import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "16px",
    color: getBrandCustom("darkPrimaryColor", "#308CDB"),
  },
  dateTitle: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "14px",
    color: "#9CA6AF",
  },
  button: {
    cursor: "pointer",
  },
  checkbox: {
    padding: 0,
  },
}));

export default styles;
